<template>
  <div class="full-height">
    <Row>
      <i-col
        :md="12"
        :xs="14"
      >
        <p class="boldtext">
          {{ $t("Account") }}
        </p>
      </i-col>
      <i-col
        v-if="isManagerOrAbove()"
        :md="12"
        :xs="10"
        align="right"
      >
        <button
          class="action-button btnContract"
          @click="triggerShowModal()"
        >
          <Icon
            type="md-add"
            size="18"
          />
          {{ $t("Invite user") }}
        </button>
        <InviteUser
          ref="inviteUser"
          v-model="showInviteUser"
          :client="client"
          :contract="contract"
          @refreshUsers="fetchContractUsers"
        />
      </i-col>
    </Row>
    <userManagement
      ref="mangeUser"
      v-model="modalData"
      :modal-on-submit="triggerManageUser"
      @hide="triggerHideModal"
    />
    <transition
      appear
      name="slide-left-centered"
    >
      <Table
        :columns="columns"
        :data="users.results"
        style="height: calc(700px)"
        class="s2ec-table accounts"
        :loading="isLoading"
      >
        <div
          slot="header"
          class="s2ec-table-header"
        >
          <Row>
            <i-col
              :md="15"
              :xs="17"
            >
              <router-link :to="{ name: 'accounts' }">
                <Icon
                  type="ios-folder-open"
                  size="27"
                  class="icon"
                />
              </router-link>
              <Icon
                type="ios-arrow-forward"
                size="27"
                class="arrow"
              />
              <router-link :to="{ name: 'contracts' }">
                <Icon
                  type="ios-contacts"
                  size="33"
                  class="arrow"
                />
              </router-link>
              <Icon
                type="ios-arrow-forward"
                size="27"
                class="arrow"
              />
              {{ contract.contract_name }}
              <span style="color: #5e5e5e; font-size: 15px">{{
                contract.contract_identifier
              }}</span>
              <span
                class="circle"
                :class="[contract.contract_is_active ? 'green' : 'red']"
              />
            </i-col>
          </Row>

          <Row
            class="md-4"
            type="flex"
          >
            <i-col
              :md="5"
              :xs="5"
              class="ml-4"
            >
              <Icon
                type="ios-key"
                size="20"
                class="smallicon"
              />
              <p
                v-if="contract.contract_user_limit === 999999"
                class="text"
              >
                {{ $t("Unlimited access") }}
              </p>
              <p
                v-else
                class="text"
              >
                {{ $t("Access") }} : {{ contract.contract_user_limit }}
              </p>
            </i-col>
            <i-col
              :md="5"
              :xs="5"
            >
              <Icon
                type="md-calendar"
                size="20"
                class="smallicon"
              />
              <p class="text">
                {{ fullDateFormat(contract.contract_start_date) }}

                <br>
                {{ fullDateFormat(contract.contract_end_date) }}
              </p>
            </i-col>
            <i-col
              :md="4"
              :xs="4"
            >
              <Icon
                v-if="contract.assistance === false"
                type="ios-mic"
                size="20"
                class="smallicon"
              />
              <Icon
                type="ios-mic"
                size="20"
                class="smallicongreen smallicon"
              />
              <p class="text">
                {{ $t("Assistance") }}
              </p>
            </i-col>
            <i-col
              :md="4"
              :xs="4"
            >
              <Icon
                type="md-at"
                size="20"
                class="smallicon"
              />
              <div
                v-for="(
                  access_domain, idx
                ) in contract.contract_access_restrictions"
                :key="idx"
              >
                <p class="text">
                  {{ access_domain.domain_or_email }}
                </p>
              </div>
            </i-col>
          </Row>
        </div>
      </Table>
    </transition>
  </div>
</template>

<script>
import InviteUser from "@/views/accounts/modals/InviteUser";
import userManagement from "@/views/accounts/modals/userManagement";
import {
  getUsers,
  getContractQry,
  getClientQry,
} from "@/services/accounts.service";
import { deleteUserQry } from "@/services/auth.service";
import {
  patcherUserQry,
  postValidateUserQry,
} from "@/services/userManagement.service"; // Fixme naming
import moment from "moment";
import DateFormat from "@/mixins/dateFormat";

export default {
  name: "Users",
  components: {
    InviteUser,
    userManagement,
  },
  mixins: [DateFormat],
  data() {
    return {
      isLoading: false,
      showInviteUser: false,
      client: {
        client_name: "",
      },
      contract: {
        contract_identifier: "",
      },
      modalData: {
        showModal: false,
        form: {},
      },
      users: {
        count: 0,
        results: [],
      },
      columns: [
        {
          title: this.$t("Users"),
          key: "full_name",
          sortable: true,
        },
        {
          title: this.$t("State"),
          key: "is_active",
          sortable: true,
          align: "center",
          render: (h, params) => {
            if (params.row.is_active === true) {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#54AD77",
                      padding: "10px",
                      border: "none",
                      width: "89px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  this.$t("Active")
                ),
              ]);
            } else if (params.row.user_onboarding_complete == false) {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#EE823A",
                      padding: "10px",
                      border: "none",
                      width: "89px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  params.row.user_onboarding_complete
                    ? this.$t("Disabled")
                    : params.row.user_origin == "INVITATION"
                    ? this.$t("Invited")
                    : this.$t("Waiting")
                ),
              ]);
            } else {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#D54848",
                      padding: "10px",
                      border: "none",
                      width: "89px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  params.row.user_onboarding_complete
                    ? this.$t("Disabled")
                    : params.row.user_origin == "INVITATION"
                    ? this.$t("Invited")
                    : this.$t("Waiting")
                ),
              ]);
            }
          },
        },
        {
          title: this.$t("Role"),
          key: this.$t("user_role"),
          width: 200,
          render: (h, params) => {
            return h("div", this.$t(params.row.user_role_display));
          },
        },
        {
          title: this.$t("Entity"),
          key: "entity",
          render: (h, params) => {
            // Resolve the entity id to its name via the org store (Lot 4).
            const name = params.row.entity
              ? this.organizationStore.entityNameById(params.row.entity)
              : "";
            return h("div", name || "—");
          },
        },
        {
          title: this.$t("Phone"),
          key: "cellphone",
        },
        {
          title: this.$t("Email"),
          key: "email",
        },
        {
          title: this.$t("Actions"),
          key: "actions",
          align: "right",
          render: (h, params) => {
            if (this.isManagerOrAbove()) {
              return [
                h("Button", {
                  props: {
                    icon: "md-create",
                  },
                  attrs: {
                    title: this.$t("Edit"),
                  },
                  class: "table-button",
                  on: {
                    click: (evt) => {
                      evt.stopPropagation(); // "click.stop" is not supported here
                      this.triggerShowUpdateModal(params.row);
                    },
                  },
                }),
                h("Button", {
                  props: {
                    icon: params.row.is_active
                      ? "md-close"
                      : params.row.user_onboarding_complete
                      ? "md-checkmark"
                      : "md-done-all",
                    disabled:
                      (!params.row.user_onboarding_complete && params.row.user_origin == "INVITATION")
                      || params.row.id == this.$store.state.userDetail.profile.id, // FIXME dirty workaround
                  },
                  attrs: {
                    title:
                      params.row.id == this.$store.state.userDetail.profile.id
                        ? this.$t("Unable to auto-deactivate")
                        : params.row.is_active
                        ? this.$t("Disable")
                        : params.row.user_onboarding_complete
                        ? this.$t("Enable")
                        : this.$t("Validate"),
                  },
                  class: "table-button",
                  on: {
                    click: (evt) => {
                      evt.stopPropagation(); // "click.stop" is not supported here
                      this.changeStateUser(
                        params.row.id,
                        params.row.is_active,
                        params.row.user_onboarding_complete
                      );
                    },
                  },
                }),
                h("Button", {
                  props: {
                    icon: "md-trash",
                    disabled: params.row.id == this.$store.state.userDetail.profile.id
                  },
                  attrs: {
                    title: params.row.id == this.$store.state.userDetail.profile.id ? this.$t("Unable to delete yourself") : this.$t("Delete"),
                  },
                  class: "table-button",
                  on: {
                    click: (evt) => {
                      evt.stopPropagation(); // "click.stop" is not supported here
                      this.removeUser(params.row.id, params.index);
                    },
                  },
                }),
              ];
            } else {
              return [];
            }
          },
        },
      ],
    };
  },
  computed: {
    contractId() {
      return this.$route.params.contractId;
    },
    clientId() {
      return this.$route.params.id;
    },
  },
  async created() {
    if (typeof this.$route.params.id == "undefined") {
      // FIXME: This few lines should may not exist
      this.$router.push({
        name: "contracts",
        params: { id: 1 },
      });
    }
    // Load org entities so the "Entity" column can resolve names (Lot 4).
    this.organizationStore.fetchEntities();
    try {
      this.isLoading = true;
      // The contract MUST be loaded first: fetchContractUsers() filters users by
      // this.contract.contract_identifier. If users were fetched before the
      // contract, the filter param was empty and ALL client users were returned
      // (users appeared in every contract). Order matters here.
      await this.fetchContract();
      await this.fetchClient();
      await this.fetchContractUsers();
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    removeUser(id, idx) {
      this.$AppModal.AppConfirm({
        extraTitle: this.$t("Delete"),
        message: this.$t(
          "You are about to delete this item. Are you sure to continue"
        ),
        loading: true,
        cancelText: this.$t("Cancel"),
        onConfirm: () => {
          deleteUserQry(id, { status: this.userStatus })
            .then(() => {
              this.users.count -= 1;
              this.users.results.splice(idx, 1);
              this.$AppModal.remove();
              this.$Message.success(this.$t("Successfully deleted user"));
            })
            .catch(() => {
              this.$AppModal.remove();
              this.$Message.error({
                content: this.$t("Error occurred deleting user"),
                duration: 5,
              });
            });
        },
      });
    },
    triggerShowModal() {
      (this.showInviteUser = false), (this.showInviteUser = true);
    },
    triggerShowUpdateModal(userData) {
      this.modalData.form = { ...userData };
      this.modalData.showModal = true;
    },
    triggerManageUser() {
      const userData = this.modalData.form;

      patcherUserQry(userData.id, { user_role: userData.user_role })
        .then(() => {
          this.$Message.success(this.$t("Successfully updated"));
          setTimeout(() => {
            this.fetchContractUsers();
          }, 500);
          this.triggerHideModal();
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred on validating the request"),
            duration: 5,
          });
          this.triggerHideModal();
        });
    },
    async fetchClient() {
      await getClientQry(this.clientId)
        .then((response) => {
          this.client = response.data;
          return response;
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred retrieving client"),
          });
        });
    },
    async fetchContract() {
      await getContractQry(this.clientId, this.contractId)
        .then((response) => {
          this.contract = response.data;
          return response;
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred retrieving contract"),
            duration: 5,
          });
        });
    },
    async fetchContractUsers() {
      // Guard: without a contract identifier the filter would be empty and the
      // API would return ALL client users (mixed across contracts). Bail out.
      if (!this.contract || !this.contract.contract_identifier) {
        this.users.results = [];
        this.users.count = 0;
        return;
      }
      const params = {
        contract: this.contract.contract_identifier,
        client: this.clientId,
        page_size: 500
      };

      await getUsers(params)
        .then((response) => {
          this.users.results = response.data.results;
          this.users.count = response.data.count;
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred retrieving users"),
            duration: 5,
          });
        });
    },
    changeStateUser(id, state, userOnboardingComplete) {
      if (!state && !userOnboardingComplete) {
        postValidateUserQry(id)
          .then(() => {
            this.$Message.success(
              this.$t("Successfully validated user registration")
            );
            setTimeout(() => {
              this.fetchContractUsers();
            }, 500);
          })
          .catch(() => {
            this.$Message.error({
              content: this.$t("Error occurred"),
              duration: 5,
            });
          });
      } else {
        patcherUserQry(id, { is_active: !state })
          .then(() => {
            this.$Message.success(this.$t("Successfully updated a user"));
            setTimeout(() => {
              this.fetchContractUsers();
            }, 500);
          })
          .catch(() => {
            this.$Message.error({
              content: this.$t("Error occurred"),
              duration: 5,
            });
          });
      }
    },
    triggerHideModal() {
      this.modalData.showModal = false;
      this.modalOnSubmit = this.triggerCreateContract;
    },
  },
};
</script>

<style>
.contract-list-action > .ivu-btn:first-of-type {
  margin-right: 20px;
}

.ivu-table-title {
  margin-bottom: 186px !important;
}
</style>